// extracted by css-extract-rspack-plugin
export default {"FilterContainer":"IssuesIndexSearch-module__FilterContainer__prSAc"};